



if(window.screen.width < 768){

   
$(document).ready(function() {
var topOfOthDiv = $(".purchase-details").offset().top;
      $(window).scroll(function() {
    if($(window).scrollTop() > topOfOthDiv) { //scrolled past the other div?
       $("body").addClass('sticky_s'); //reached the desired point -- show div
    } else {
       $("body").removeClass('sticky_s'); //reached the desired point -- hide div
    }
  });
});
}
else{


$(document).ready(function() {
var topOfOthDiv = $(".description").offset().top;
      $(window).scroll(function() {
    if($(window).scrollTop() > topOfOthDiv) { //scrolled past the other div?
       $("body").addClass('sticky_s'); //reached the desired point -- show div
    } else {
       $("body").removeClass('sticky_s'); //reached the desired point -- hide div
    }
  });
});
  
  
}